import React from 'react';
import { Navigate, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import RouteGuard from '../shared/RouteGuard';
import GuestsView from './guests/GuestsView';
import DoorCheckInView from './checkin/DoorCheckInView';

// The /events/:engagementId/guests door ("Guests & RSVP"). Same gate as /events: closed unless the Events pack is on for this
// organization (capability AND an Events entity); anyone else who types the address lands on the dashboard.
// G5: ?door=1 on the same address is the event's door scanner (Events edit; the database checks every scan again).
export default function EventGuestsRoute({ enabled, loading, userId, isUser }) {
    const { engagementId } = useParams();
    const [params] = useSearchParams();
    const navigate = useNavigate();
    if (loading) return <div className="p-8 text-center text-gray-400">Loading…</div>;
    if (!enabled) return <Navigate to="/dashboard" replace />;
    const guestsPath = `/events/${engagementId}/guests`;
    if (params.get('door') === '1') {
        return (
            <RouteGuard module="events" action="edit" isUser={isUser}>
                <DoorCheckInView engagementId={engagementId} userId={userId} isUser={isUser} onBack={() => navigate(guestsPath)} onEvents={() => navigate('/events')} />
            </RouteGuard>
        );
    }
    return (
        <RouteGuard module="events" action="view" isUser={isUser}>
            <GuestsView engagementId={engagementId} userId={userId} isUser={isUser} onBack={() => navigate('/events')} onOpenDoor={() => navigate(`${guestsPath}?door=1`)} />
        </RouteGuard>
    );
}
